export const signInAdminWithGoogle = `
  mutation SignInAdminWithGoogle($credential: String!) {
    signInAdminWithGoogle(credential: $credential) {
      success
      message
      token
      email
    }
  }
`;

export const signOutAdmin = `
  mutation SignOutAdmin {
    signOutAdmin
  }
`;
